import '../browser/elements/index.js';
import {
  AdClick,
  CategoryView,
  ClickTracker,
  CompareView,
  CompetitorsView,
  LeadCreateClick,
  PricingView,
  ProfileView,
  SessionProvider,
  SubjectTracker,
  ViewTracker,
  WriteReviewView,
} from '../browser/components/index.js';

export {
  SessionProvider,
  SubjectTracker,
  ViewTracker,
  ClickTracker,
  ProfileView,
  PricingView,
  CompetitorsView,
  CategoryView,
  CompareView,
  WriteReviewView,
  AdClick,
  LeadCreateClick,
};

export const BuyerIntent = {
  Session: SessionProvider,
  Subject: SubjectTracker,
  View: ViewTracker,
  Click: ClickTracker,
  ViewTracker,
  ClickTracker,
  ProfileView,
  PricingView,
  CompetitorsView,
  CategoryView,
  CompareView,
  WriteReviewView,
  AdClick,
  LeadCreateClick,
};
